<template>
  <v-select
    label="Condición*"
    v-model="iModel"
    :items="items"
    item-value="Id_CondicionVenta"
    item-text="NombreCondicionVenta"
    :rules="rules"
    :readonly="readonly"
    :loading="loading"
    solo
  >
    <template v-slot:no-data
      >No hay datos para mostrar</template
    >
    <template v-slot:progress>
      <v-progress-circular color="blue" indeterminate></v-progress-circular>
    </template>
  </v-select>
</template>

<script>
import HttpHelper from "@/store/HttpHelper";
export default {
  name: "SelectCondicionVenta",
  props: {
    id_TipoComprobante: Number,
    model: Number,
    rules: {},
    readonly: Boolean
  },
  data() {
    return {
      itemActivo: {
        Id_CondicionVenta: 0
      },
      items: [],
      loading: false
    };
  },
  watch: {
    id_TipoComprobante(valor) {
      this.listarItems(valor);
    }
  },
  computed: {
    iModel: {
      get() {
        return this.itemActivo.Id_CondicionVenta;
      },
      set(valor) {
        this.itemActivo.Id_CondicionVenta = valor;
        if (valor != undefined && valor > 0) {
          var ind = this.items.findIndex(x => x.Id_CondicionVenta == valor);
          this.$emit("seleccionarItem", this.items[ind]);
        }
      }
    }
  },
  methods: {
    listarItems(id) {
      this.items = [];
      if (id != undefined && id > 0) {
        this.loading = true;
        HttpHelper.get(
          "TipoComprobante_CondicionVenta/ListarPorTipoComprobante",
          {
            id: id
          }
        )
          .then(response => {
            this.items = response.data;
            if (this.items.length > 0)
              this.iModel = this.items[0].Id_CondicionVenta;
            this.loading = false;
          })
          .catch(error => {
            return Promise.reject(error);
          });
      }
    }
  }
};
</script>
